export const SHOPIFY_CONFIG = {
  STOREFRONT_TOKEN: '230d3c66ca696fe17707d4e77a304389',
  SHOPIFY_STORE_URL: `https://${window.Shopify.shop}`,
  SUPER_MARQUEE_LICENSE: 'B7FE1E0B-31904038-86729432-9D29340A',
};
